/* ========================================
   GLOBAL JS - Cart, Header, Search, Drawer
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  initHeaderScroll();
  initCartDrawer();
  initMobileMenu();
  initSearchToggle();
  initQuantityInputs();
  initCartRemoveButtons();
  initCartAddForms();
  initBuyNowButton();
  initThemeToggle();
  initCollectionSearch();
  initCollectionQuickAdd();
});

/* ---------- Header scroll behavior ---------- */
function initHeaderScroll() {
  const header = document.querySelector('.shopify-section-header');
  if (!header) return;

  let lastScroll = 0;
  const scrollThreshold = 50;

  window.addEventListener('scroll', function() {
    const currentScroll = window.scrollY;

    if (currentScroll > scrollThreshold) {
      header.classList.add('shopify-section-header--scrolled');
      header.classList.remove('shopify-section-header--transparent');
    } else {
      header.classList.remove('shopify-section-header--scrolled');
      header.classList.add('shopify-section-header--transparent');
    }

    lastScroll = currentScroll;
  }, { passive: true });
}

/* ---------- Cart Drawer ---------- */
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const toggleBtns = document.querySelectorAll('[data-cart-toggle]');
  const closeBtn = drawer?.querySelector('[data-cart-close]');
  const overlay = drawer?.querySelector('[data-cart-overlay]');

  if (!drawer) return;

  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      drawer.toggleAttribute('open');
      document.body.style.overflow = drawer.hasAttribute('open') ? 'hidden' : '';
    });
  });

  closeBtn?.addEventListener('click', () => {
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
  });

  overlay?.addEventListener('click', () => {
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.hasAttribute('open')) {
      drawer.removeAttribute('open');
      document.body.style.overflow = '';
    }
  });
}

/* ---------- Mobile Menu ---------- */
function initMobileMenu() {
  const drawer = document.getElementById('HeaderDrawer');
  const toggleBtn = document.querySelector('[data-menu-toggle]');
  const closeBtn = drawer?.querySelector('[data-drawer-close]');
  const overlay = drawer?.querySelector('[data-drawer-overlay]');

  if (!drawer) return;

  toggleBtn?.addEventListener('click', () => {
    drawer.toggleAttribute('open');
    document.body.style.overflow = drawer.hasAttribute('open') ? 'hidden' : '';
  });

  closeBtn?.addEventListener('click', () => {
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
  });

  overlay?.addEventListener('click', () => {
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
  });
}

/* ---------- Search Toggle ---------- */
function initSearchToggle() {
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchContainer = document.querySelector('[data-search-container]');
  const searchInput = searchContainer?.querySelector('input');

  if (!searchToggle || !searchContainer) return;

  searchToggle.addEventListener('click', () => {
    searchContainer.classList.toggle('is-active');
    if (searchContainer.classList.contains('is-active')) {
      searchInput?.focus();
    }
  });

  document.addEventListener('click', (e) => {
    if (!searchContainer.contains(e.target) && !searchToggle.contains(e.target)) {
      searchContainer.classList.remove('is-active');
    }
  });
}

/* ---------- Quantity Inputs (product page + cart drawer) ---------- */
function initQuantityInputs() {
  document.querySelectorAll('[data-quantity]').forEach(container => {
    const input = container.querySelector('input');
    const display = container.querySelector('span[data-quantity-display], span:not([data-quantity-minus]):not([data-quantity-plus])');
    const minus = container.querySelector('[data-quantity-minus]');
    const plus = container.querySelector('[data-quantity-plus]');
    const lineKey = container.closest('[data-line]')?.dataset.line;

    minus?.addEventListener('click', () => {
      if (lineKey) {
        // Cart drawer: update via AJAX
        const currentVal = parseInt(display?.textContent) || 1;
        if (currentVal > 1) {
          updateCartItem(lineKey, currentVal - 1);
        }
      } else if (input) {
        const val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    plus?.addEventListener('click', () => {
      if (lineKey) {
        const currentVal = parseInt(display?.textContent) || 1;
        updateCartItem(lineKey, currentVal + 1);
      } else if (input) {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
}

/* ---------- Cart Remove Buttons ---------- */
function initCartRemoveButtons() {
  document.querySelectorAll('[data-remove-item]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const item = btn.closest('[data-line]');
      const lineKey = item?.dataset.line;
      if (lineKey) {
        updateCartItem(lineKey, 0);
      }
    });
  });
}

/* ---------- Cart Add Forms (AJAX add to cart) ---------- */
function initCartAddForms() {
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      const submitter = e.submitter;

      // If "Buy Now" clicked, let normal form POST happen (return_to=/checkout)
      if (submitter && (submitter.name === 'checkout' || submitter.id === 'BuyNowBtn')) {
        return; // do not preventDefault
      }

      e.preventDefault();
      const submitBtn = submitter || form.querySelector('[type="submit"][name="add"]');
      const originalText = submitBtn?.textContent || '';

      try {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Añadiendo...';
        }

        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error('Add to cart failed');

        await updateCartDrawer();

        // Open cart drawer to show the added item
        const drawer = document.getElementById('CartDrawer');
        if (drawer) {
          drawer.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
        }

        if (submitBtn) {
          submitBtn.textContent = '¡Añadido!';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        }
      } catch (err) {
        console.error('Cart add error:', err);
        if (submitBtn) {
          submitBtn.textContent = 'Error';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        }
      }
    });
  });
}

/* ---------- Cart AJAX Utilities ---------- */
async function updateCartItem(lineKey, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });

    if (!response.ok) throw new Error('Cart update failed');
    const cart = await response.json();
    await updateCartDrawer();
    updateCartCount(cart.item_count);
  } catch (err) {
    console.error('Cart update error:', err);
  }
}

async function updateCartDrawer() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    renderCartDrawer(cart);
    updateCartCount(cart.item_count);
  } catch (err) {
    console.error('Cart drawer update error:', err);
  }
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function renderCartDrawer(cart) {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const itemsContainer = drawer.querySelector('[data-cart-items]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const title = drawer.querySelector('.cart-drawer__title');

  if (title) title.textContent = `Tu carrito (${cart.item_count})`;

  if (cart.items.length === 0) {
    if (itemsContainer) {
      itemsContainer.innerHTML = `
        <div style="text-align:center;padding:6rem 2rem;">
          <p style="font-size:1.6rem;color:var(--color-text-light);margin-bottom:2rem;">Tu carrito está vacío</p>
          <a href="/collections/all" class="btn btn-primary">Explorar productos</a>
        </div>
      `;
    }
    if (footer) footer.style.display = 'none';
    return;
  }

  if (footer) footer.style.display = '';

  if (itemsContainer) {
    itemsContainer.innerHTML = cart.items.map(item => `
      <div class="cart-drawer__item" data-cart-item data-line="${item.key}">
        <div class="cart-drawer__item-image">
          <img src="${item.image}" alt="${item.title}" loading="lazy" width="80" height="80">
        </div>
        <div class="cart-drawer__item-details">
          <div>
            <div class="cart-drawer__item-title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-variant">${item.variant_title}</div>` : ''}
          </div>
          <div class="cart-drawer__item-bottom">
            <div class="cart-drawer__qty" data-quantity>
              <button data-quantity-minus type="button" aria-label="Disminuir">-</button>
              <span data-quantity-display>${item.quantity}</span>
              <button data-quantity-plus type="button" aria-label="Aumentar">+</button>
            </div>
            <span class="font-heading" style="font-size:1.4rem;">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
        <button data-remove-item class="btn btn-ghost" style="align-self:flex-start;" aria-label="Eliminar">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M2 4h12M6 4V2a1 1 0 011-1h2a1 1 0 011 1v2m3 0v10a2 2 0 01-2 2H5a2 2 0 01-2-2V4"/>
          </svg>
        </button>
      </div>
    `).join('');
  }

  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  // Re-initialize event listeners on new elements
  initQuantityInputs();
  initCartRemoveButtons();
}

/* ---------- Format Money Helper ---------- */
function formatMoney(cents) {
  const value = (cents / 100).toFixed(2).replace('.', ',');
  return `${value} €`;
}

/* ---------- Theme Toggle ---------- */
function initThemeToggle() {
  const toggle = document.querySelector('[data-theme-toggle]');
  if (!toggle) return;

  toggle.addEventListener('click', () => {
    const html = document.documentElement;
    const current = html.getAttribute('data-theme') || 'light';
    const next = current === 'light' ? 'dark' : 'light';
    html.setAttribute('data-theme', next);
    try { localStorage.setItem('blisart-theme', next); } catch(e) {}
  });
}

/* ---------- Buy Now Button ---------- */
function initBuyNowButton() {
  const buyBtn = document.getElementById('BuyNowBtn');
  if (!buyBtn) return;

  buyBtn.addEventListener('click', async () => {
    const form = buyBtn.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    const originalText = buyBtn.textContent;

    try {
      buyBtn.disabled = true;
      buyBtn.textContent = 'Procesando...';

      // First clear the cart to ensure only this item is bought
      await fetch('/cart/clear.js', { method: 'POST' });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.description || 'Add to cart failed');
      }

      // Redirect to checkout
      window.location.href = '/checkout';
    } catch (err) {
      console.error('Buy now error:', err);
      buyBtn.textContent = 'Error';
      setTimeout(() => {
        buyBtn.textContent = originalText;
        buyBtn.disabled = false;
      }, 1500);
    }
  });
}

/* ---------- Collection Search Dropdown ---------- */
function initCollectionSearch() {
  const toggleBtn = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-collection-search]');

  if (!toggleBtn || !searchPanel) return;

  toggleBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    searchPanel.classList.toggle('is-open');
    if (searchPanel.classList.contains('is-open')) {
      const input = searchPanel.querySelector('input[type="search"]');
      input?.focus();
    }
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (searchPanel.classList.contains('is-open') &&
        !searchPanel.contains(e.target) &&
        !toggleBtn.contains(e.target)) {
      searchPanel.classList.remove('is-open');
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) {
      searchPanel.classList.remove('is-open');
    }
  });
}

/* ---------- Collection Quick Add (AJAX from grid) ---------- */
function initCollectionQuickAdd() {
  document.querySelectorAll('[data-quick-add-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-quick-add-text]')?.parentElement || form.querySelector('button[type="submit"]');
      const textSpan = form.querySelector('[data-quick-add-text]');
      const originalText = textSpan?.textContent || 'Anadir al carrito';

      try {
        if (btn) {
          btn.disabled = true;
          if (textSpan) textSpan.textContent = 'Anadiendo...';
        }

        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.description || 'Add to cart failed');
        }

        const cart = await response.json();
        updateCartCount(cart.item_count);
        await updateCartDrawer();

        // Visual feedback
        if (btn) {
          btn.classList.add('product-card__quick-add-btn--added');
          if (textSpan) textSpan.textContent = 'Anadido!';
        }

        // Open cart drawer briefly to confirm
        const drawer = document.getElementById('CartDrawer');
        if (drawer) {
          drawer.setAttribute('open', '');
          document.body.style.overflow = 'hidden';
        }

        // Reset after delay
        setTimeout(() => {
          if (btn) {
            btn.classList.remove('product-card__quick-add-btn--added');
            btn.disabled = false;
            if (textSpan) textSpan.textContent = originalText;
          }
        }, 2000);

      } catch (err) {
        console.error('Quick add error:', err);
        if (btn) {
          if (textSpan) textSpan.textContent = 'Error';
          setTimeout(() => {
            btn.disabled = false;
            if (textSpan) textSpan.textContent = originalText;
          }, 1500);
        }
      }
    });
  });
}

/* ---------- Backwards compat with Dawn-style calls ---------- */
if (!window.Shopify) window.Shopify = {};
window.Shopify.formatMoney = function(cents, format) {
  if (typeof format !== 'string') format = '${{amount}}';
  const value = (cents / 100).toFixed(2);
  return format.replace('{{amount}}', value).replace('{{amount_no_decimals}}', Math.round(cents/100));
};
